import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Icon,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  Pagination,
  PaginationItem,
  Paper,
  Select,
  Stack,
  styled,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import * as Yup from "yup";
import { useFormik } from "formik";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import TableRowWithSpeedometer from "../comman/Speedometer";
import GaugeChart from "react-gauge-chart";
import Speedometer from "../comman/Speedometer";
import ToggleEnableImage from "../comman/ToggleEnbaleImage.svg";
import API from "../comman/API";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { authHeader } from "../comman/MainFunction";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";
import customerNodata from "../../images/Alert-icon-green.jpg";
import {
  DELETE_ATTACHMENT_LOG_BY_ID_URL,
  DELETE_NTE_DETAILS,
  GET_PROJECT_DETAILS_BY_ID_URL,
  INSERT_NOTIFICATION_DETAILS,
  UPSERT_NTE_DETAILS,
} from "../../constants/ApiRoute";
import { useToast } from "../comman/CustomMessages";
import RemoveNTEthreshold from "../model/RemoveNTEthreshold";
import NoRecordFound from "../comman/NoRecordFound";
import { useDispatch, useSelector } from "react-redux";
import { getAllNotificationDetails } from "../../redux/action";
import emailSchema from "../comman/validation/EmailSchema";
import AddIcon from "@mui/icons-material/Add";
import SaveValidationModel from "../model/SaveValidationModel";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
    "&.Mui-disabled": {
      color: theme.palette.action.disabled, // Match disabled color
      "& + .MuiSwitch-track": {
        opacity: 3.12,
        backgroundColor: theme.palette.action.disabledBackground, // Match disabled track color
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
    "&.Mui-disabled": {
      opacity: 0.5,
      backgroundColor: theme.palette.action.disabledBackground, // Adjust disabled track color
    },
  },
}));

export default function ProjectNTEdetails(props) {
  const {
    projectDetails,
    getprojectDetails,
    NTEDetails,
    locationList,
    setProjectDetails,
    setNTEDetails,
    setLoading,
  } = props;
  console.log(projectDetails, "projectDetailsprojectDetails");
  console.log(NTEDetails, "NTEDetailsNTEDetailsNTEDetails");
  const dispatch = useDispatch();
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  const [errorTextEmail, setErrorTextEmail] = useState("");
  console.log(errorTextEmail, "errorTextEmailerrorTextEmail");

  const spanStyle = {
    backgroundColor: isHovered ? "#00ffff" : "#e3f2fd",
    color: isHovered ? "#0d47a1" : "#0d47a1",
    padding: "5px 10px",
    borderRadius: "5px",
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
  };
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const notificationDetails = useSelector(
    (item) => item?.AllNotificationDetailsReducer
  );
  const showToast = useToast();
  const [orderBy, setOrderBy] = useState("WarningMeter"); // Column to sort
  const [orderDirection, setOrderDirection] = useState("asc"); // asc or desc

  const [addNewNTE, setAddNewNTE] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [editNTEvalues, setEditNTEvalues] = useState(false);
  const [nteAmountValue, setNTEAmountValue] = useState("10.00");
  // const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emails, setEmails] = useState([]);
  const [removeModel, setRemoveModel] = useState(false);
  const [removeItem, setRemoveItem] = useState("");
  const [saveValidationModel, setSaveValidationModel] = useState(false);
  const [warningBorder, setWarningBorder] = useState(false);
  const [changedFields, setChangedFields] = useState(new Set());
  const [savePopupMessage, setSavePopupMessage] = useState({});
  const [isFocused, setIsFocused] = useState(false);
  const [page, setPage] = useState(1);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [focusedIndexWarning, setFocusedIndexWarning] = useState(null);
  const rowsPerPage = 5;
  console.log(savePopupMessage, "pageesavePopupMessageeeeeeeee");

  console.log(emails?.length, "emailaaaaaaaaaaa", email?.length);

  // Email validation regex
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validationSchema = Yup.object().shape({
    nteAmount: Yup.string()
      .required("NTE amount is required")
      .matches(
        /^\d*(\.\d{0,2})?$/,
        "Enter a valid number with up to 2 decimal places"
      )
      .test(
        "not-zero",
        "NTE amount must be greater than '0'",
        (value) =>
          value !== undefined && value !== null && parseFloat(value) > 0
      ),
    alertName: Yup.string()
      // .matches(/^[A-Za-z\s.,-]*$/, "Alert Name must contain only letters")
      .required("Alert name is required"),
    threshold: Yup.number()
      .typeError("Enter a valid number")
      .min(0, "Threshold cannot be less than 0")
      .max(100, "Threshold cannot exceed 100")
      .test(
        "is-decimal",
        "Threshold must have up to 2 decimal places",
        (value) =>
          value
            ? /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{0,2})?|\.([0-9]{1,2})?)?$/.test(
                value
              )
            : true
      )
      .test(
        "greater-than-zero",
        "Threshold (%) must be greater than '0'.",
        (value) => {
          // Convert value to a number for comparison
          const numValue = parseFloat(value);
          return !isNaN(numValue) && numValue > 0;
        }
      )
      .required("Threshold is required"),
    email: Yup.array()
      .of(
        Yup.string()
          .email("Invalid email format")
          .required("Each email must be valid")
      )
      .test("is-not-empty", function (value, context) {
        const { isTyping } = this.options.context || {};
        if (isTyping) {
          // Skip validation if typing
          return true;
        }
        console.log(value, "valueeeeeeeeeee", email?.length);

        if (errorTextEmail == "" && email?.length > 0) {
          return this.createError({
            message:
              "Email recipient not added. Please click 'Add' to proceed.",
          });
        }
        // If the array is empty
        else if ((errorTextEmail == "" && !value) || value.length === 0) {
          return this.createError({
            message: "At least one email is required.",
          });
        }
        // If the array contains an empty string or invalid email
        return true; // Validation passed
      }),
  });

  const validationSchema1 = Yup.object().shape({
    NTEDetails: Yup.array().of(
      Yup.object().shape({
        Description: Yup.string()
          .required("Alert Name is required")
          .max(200, "Alert Name cannot exceed 200 characters"),
        WarningMeter: Yup.string()
          .required("Threshold (%) is required")
          .matches(
            /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{0,2})?|\.([0-9]{1,2})?)?$/,
            "Enter a valid number between 0 and 100 with up to 2 decimal places"
          )
          .test(
            "greater-than-zero",
            "Threshold (%) must be greater than '0'.",
            (value) => {
              // Convert value to a number for comparison
              const numValue = parseFloat(value);
              return !isNaN(numValue) && numValue > 0;
            }
          ),
      })
    ),
    nteAmount: Yup.string()
      .required("NTE amount is required") // Check for empty strings
      .matches(
        /^\d*(\.\d{0,2})?$/,
        "Enter a valid number with up to 2 decimal places"
      )
      .test(
        "not-zero",
        "NTE amount must be greater than '0'",
        (value) =>
          value !== undefined && value !== null && parseFloat(value) > 0
      ),
    email: Yup.array()
      .of(
        Yup.string()
          .email("Invalid email format")
          .required("Each email must be valid")
      )
      .test("is-not-empty", function (value, context) {
        const { isTyping } = this.options.context || {};
        if (isTyping) {
          // Skip validation if typing
          return true;
        }
        console.log(value, "valueeeeeeeeeee", email?.length);

        if (errorTextEmail == "" && email?.length > 0) {
          return this.createError({
            message:
              "Email recipient not added. Please click 'Add' to proceed.",
          });
        }
        // If the array is empty
        else if ((errorTextEmail == "" && !value) || value.length === 0) {
          return this.createError({
            message: "At least one email is required.",
          });
        }
        // If the array contains an empty string or invalid email
        return true; // Validation passed
      }),
  });

  const {
    handleSubmit,
    handleChange,
    values,
    setValues,
    errors,
    touched,
    resetForm,
    setFieldValue,
    setFieldTouched,
    setErrors,
    handleBlur,
    validateForm,
    setFieldError,
  } = useFormik({
    initialValues: {
      nteAmount: projectDetails[0]?.NTEAmount
        ? parseFloat(projectDetails[0].NTEAmount).toFixed(2)
        : "0.00", // Default to "0.00" if NTEAmount is invalid
      threshold: "",
      alertName: "",
      email: projectDetails[0]?.Emails
        ? projectDetails[0].Emails.split(",").map((email) => email.trim())
        : [], // Default to an empty array if Emails is invalid
      totalValue: projectDetails[0]?.TotalAmount || "0.00", // Default to "0.00" if TotalAmount is invalid
      IsNTEEnabled: !!projectDetails[0]?.IsNTEEnabled, // Convert null/undefined/false to false
      NTEDetails: (NTEDetails || []).map((item) => ({
        ...item,
        WarningMeter:
          item.WarningMeter == 100
            ? item.WarningMeter
            : parseFloat(item.WarningMeter).toFixed(2),
      })),
    },

    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values?.email?.length, email.length, "emaiiiiiilsssss");
      if (values?.email?.length === 0 && email?.length == 0) {
        setErrorTextEmail("Atleast one email is required.");
      } else if (email?.length > 0) {
        setErrorTextEmail(
          "Email recipient not added. Please click 'Add' to proceed."
        );
      } else if (values?.email.length > 0) {
        console.log("API_CALLING");
        hanldeAddNewTHresold(values);
        setErrorTextEmail("");
      } else {
        console.log("Email is required and cannot be empty.");
        return;
      }
    },
  });

  console.log(projectDetails, "projectDetails[0]?.IsNTEEnabled");
  console.log(values, "jhsakjhdkjsahkjdgash");
  console.log(touched, "jhsakjhdkjsahkjdgashtouchedtouched", errors);
  const handleAddEmail = async () => {
    try {
      // Validate the email using emailSchema
      await emailSchema.validate(email);

      // Check if the email already exists
      if (emailExists(email)) {
        setErrorTextEmail("Email already exists.");
      } else {
        // Update local emails array
        setEmails((prev) => [...prev, email]);

        // Clear the input field
        setEmail("");
        setErrorTextEmail(" ");

        // Update the state with the combined emails
        setValues((prev) => ({
          ...prev,
          email: [...prev.email, email], // Add the new email to the existing array
        }));
      }
    } catch (error) {
      console.log(error, "errorrrr");
      // Handle validation errors
      setErrorTextEmail(error.message);
    }
  };

  const handleRemoveEmail = (emailToRemove) => {
    // Update local emails array
    setEmails((prev) => prev.filter((e) => e !== emailToRemove));

    // Update the state after removing the email
    setValues((prev) => ({
      ...prev,
      email: prev.email.filter((e) => e !== emailToRemove),
    }));
  };

  const openAddNewNTE = (value) => {
    setAddNewNTE(!addNewNTE);
  };
  const handleClose = () => {
    setAddNewNTE(!addNewNTE);
    // Assuming `email` is an array
    // setEmail(email);
    resetForm({
      values: {
        nteAmount: projectDetails[0]?.NTEAmount
          ? parseFloat(projectDetails[0].NTEAmount).toFixed(2)
          : "0.00",
        threshold: "",
        alertName: "",
        email: projectDetails[0]?.Emails
          ? projectDetails[0].Emails.split(",").map((email) => email.trim())
          : [],
        totalValue: projectDetails[0]?.TotalAmount || "0.00",
        IsNTEEnabled: !!projectDetails[0]?.IsNTEEnabled,
      },
    });
    setEmail("");
    setErrorTextEmail("");
    setPage(1);
  };
  const opeEditNTEValues = (value) => {
    setEditNTEvalues(!editNTEvalues);
    // setPage(1);
  };
  const handleCloseNTEValues = () => {
    setEditNTEvalues(!editNTEvalues);
  };

  const handleToggleChange = (e) => {
    const { checked } = e?.target;
    console?.log(e, "Toggle Event");
    setValues((prev) => ({
      ...prev,
      IsNTEEnabled: checked,
    }));
    const updatedValues = {
      ...values,
      IsNTEEnabled: checked, // Include the updated value
    };
    hanldeUpsertNTEDeatils(updatedValues, "NTEdisabled");
    setPage(1);
  };
  const handleToggleChange1 = (e) => {
    const { checked } = e?.target;
    showToast("Please save or cancel your changes before continuing.", "info");
  };

  const handleNTEInputChange = (e) => {
    const { value } = e.target;
    // Allow only valid numbers with up to two decimal places
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setNTEAmountValue(value);
    }
  };
  const handleClickCancel = () => {
    setEditNTEvalues(false);
    resetForm({
      values: {
        nteAmount: projectDetails[0]?.NTEAmount
          ? parseFloat(projectDetails[0].NTEAmount).toFixed(2)
          : "0.00",
        threshold: "",
        alertName: "",
        email: projectDetails[0]?.Emails
          ? projectDetails[0].Emails.split(",").map((email) => email.trim())
          : [],
        totalValue: projectDetails[0]?.TotalAmount || "0.00",
        IsNTEEnabled: !!projectDetails[0]?.IsNTEEnabled,
      },
    });
    setEmail("");
    setErrorTextEmail("");
    setPage(1);
    setChangedFields(new Set());
  };

  const hanldeUpsertNTEDeatils = async (value, toggle, editAction) => {
    setButtonLoading(true);
    const nteAmount = parseFloat(value?.nteAmount); // Convert to number

    // Ensure the value is valid and format it to 2 decimal places
    const formattedNTEAmount = !isNaN(nteAmount)
      ? nteAmount.toFixed(2)
      : "0.00";
    console.log(value, "valueeeeeeeeeeee");
    let postData = {
      projectId: projectDetails[0]?.ProjectID,
      NTEAmount: formattedNTEAmount,
      emails: value?.email?.length > 0 ? value?.email : [],
      isNTEEnabled: value?.IsNTEEnabled === true ? 1 : 0,
      NTEDetails: value?.NTEDetails?.map((detail) => ({
        id: detail?.ID || 0,
        warningMeter: detail.WarningMeter
          ? Number(detail.WarningMeter).toFixed(2)
          : "", // Extract WarningMeter
        description: detail.Description || "", // Extract Description
      })),
    };
    const config = {
      method: "POST",
      url: UPSERT_NTE_DETAILS,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        if (editAction == "Edit") {
          showToast("Saved successfully.", "success");
          getprojectDetails();
        } else {
          getprojectDetails12(toggle, value);
        }
        setEmail("");
        setErrorTextEmail("");
        setSaveValidationModel(false);
        setChangedFields(new Set());
        setSavePopupMessage({});
        setEditNTEvalues(false);
        setButtonLoading(false);
        return null;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
        setButtonLoading(false);
      }
    } finally {
      setButtonLoading(false);
      setPage(1);
    }
  };

  const hanldeAddNewTHresold = async (value, toggle) => {
    setButtonLoading(true);
    const nteAmount = parseFloat(value?.nteAmount); // Convert to number

    // Ensure the value is valid and format it to 2 decimal places
    const formattedNTEAmount = !isNaN(nteAmount)
      ? nteAmount.toFixed(2)
      : "0.00";
    console.log(value, "valueeeeeeeeeeee");

    const updatedNTEDetails = [
      ...(value?.NTEDetails?.map((detail) => ({
        id: detail?.ID || 0,
        warningMeter: detail.WarningMeter || "0", // Extract only WarningMeter
        description: detail.Description || "", // Extract only Description
      })) || []), // Retain previous NTEDetails
      {
        id: 0,
        warningMeter: value?.threshold || "", // Use the new threshold (replace with actual value)
        description: value?.alertName || "", // Use the new alertName (replace with actual value)
      },
    ];

    console.log(updatedNTEDetails, "updatedNTEDetails");
    let postData = {
      projectId: projectDetails[0]?.ProjectID,
      NTEAmount: formattedNTEAmount,
      emails: value?.email?.length > 0 ? value?.email : [],
      isNTEEnabled: value?.IsNTEEnabled === true ? 1 : 0,
      NTEDetails: updatedNTEDetails || [],
    };
    const config = {
      method: "POST",
      url: UPSERT_NTE_DETAILS,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        const threshold = value?.threshold
          ? parseFloat(value?.threshold)?.toFixed(2)
          : "N/A";
        const projectName = projectDetails[0]?.Name || "Unknown Project";

        showToast(
          `Threshold of '${threshold}%' has been successfully added to Project '${projectName}'.`,
          "success"
        );

        getprojectDetails();
        dispatch(getAllNotificationDetails());
        setEditNTEvalues(false);
        setAddNewNTE(false);
        setButtonLoading(false);
        return null;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
        setButtonLoading(false);
      }
    } finally {
      setButtonLoading(false);
    }
  };

  const generatePayload = (values, ProjectDeatils, NTEDetails1) => {
    const payload = {
      details: [],
      thresholdDetails: [],
    };

    // Check if NTE amount has changed
    if (values?.nteAmount != ProjectDeatils[0]?.NTEAmount) {
      payload.details.push({
        description: `The budget for Project '${
          projectDetails[0]?.Name
        }' has been adjusted from $${Number(
          projectDetails[0]?.NTEAmount || 0
        ).toFixed(2)} to $${Number(values?.nteAmount || 0).toFixed(
          2
        )}. Current billing is $${Number(values?.totalValue || 0).toFixed(
          2
        )}, exceeding ${NTEPercentage()}% of the new budget.`,
      });
    }

    // Check for threshold changes in NTEDetails
    const thresholdChanges = values?.NTEDetails?.filter((nteDetail) => {
      const matchingDetail = NTEDetails1.find(
        (detail) => detail.ID == nteDetail.ID
      );
      return (
        matchingDetail && matchingDetail.WarningMeter != nteDetail.WarningMeter
      );
    });

    console.log(thresholdChanges, "thresholdChangesthresholdChanges");

    // Add a description for each threshold change
    thresholdChanges.forEach((change) => {
      const originalDetail = NTEDetails1.find(
        (detail) => detail.ID === change.ID
      );
      payload.thresholdDetails.push({
        description: `The threshold for Project '${
          projectDetails[0]?.Name
        }' has been changed from ${Number(originalDetail.WarningMeter)?.toFixed(
          2
        )}% to ${Number(change.WarningMeter)?.toFixed(
          2
        )}%. Current billing is $${Number(values?.totalValue || 0).toFixed(
          2
        )}, exceeding the new threshold of ${Number(
          change.ExceededThreshold
        )?.toFixed(2)}%.`,
      });
    });

    return payload;
  };

  const handleInsertNotificationDetails = async (detailsNte, toggle, value) => {
    setButtonLoading(true);
    console.log(toggle, value, "payloatoggle, valueddddddddddddd");
    const payload = generatePayload(values, projectDetails, detailsNte);

    // const projectBudgetAdjust = `The budget for Project Alpha has been adjusted from $${'100,000'} to $${'90,000'}. Current billing is $${'75,000'}, exceeding 70% of the new budget.'}`
    // const thresholdAdjust = `The budget for Project Alpha has been adjusted from $${'100,000'} to $${'90,000'}. Current billing is $${'75,000'}, exceeding 70% of the new budget.'}`

    // console.log(updatedNTEDetails, "updatedNTEDetails");
    let postData = {
      projectId: projectDetails[0]?.ProjectID,
      details: [],
    };

    const config = {
      method: "POST",
      url: INSERT_NOTIFICATION_DETAILS,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(postData)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        if (toggle) {
          if (value?.IsNTEEnabled === true) {
            showToast(
              "NTE is enabled. You will track exceedances and receive alerts.",
              "info"
            );
          }
        }
        dispatch(getAllNotificationDetails());
        setButtonLoading(false);
        return null;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "info");
        setButtonLoading(false);
      }
    } finally {
      setButtonLoading(false);
    }
  };

  const getprojectDetails12 = async (toggle, value) => {
    setLoading(true);
    let data = {
      projectId: locationList || 0,
    };
    const config = {
      method: "GET",
      url: GET_PROJECT_DETAILS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        setProjectDetails(parsedResponse.ProjectDetails);
        const newSort = parsedResponse?.NTEDetails?.sort(
          (a, b) => a?.WarningMeter - b?.WarningMeter
        );
        setNTEDetails(newSort);
        handleInsertNotificationDetails(
          parsedResponse?.NTEDetails,
          toggle,
          value
        );
      }
      setLoading(false);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
      setLoading(false);
    }
  };

  const NTEPercentage = () => {
    // Ensure NTEAmount is valid
    const nteAmount = parseFloat(projectDetails[0]?.NTEAmount) || 0;

    // Ensure totalValue is valid
    const totalValue = parseFloat(values?.totalValue) || 0;

    // Check for valid values to avoid division errors
    if (totalValue <= 0 || nteAmount <= 0) {
      console.log("Invalid inputs: totalValue or nteAmount is 0 or negative");
      return "0.00"; // Default value for invalid inputs
    }

    // Calculate the percentage
    const percentage = ((totalValue / nteAmount) * 100).toFixed(2);

    // Ensure the value is always positive
    const adjustedPercentage = Math.abs(parseFloat(percentage)).toFixed(2);

    console.log(adjustedPercentage, "percentage");
    return adjustedPercentage;
  };

  console.log(NTEPercentage(), "NTEPercentageNTEPercentage");

  const emailExists = (email) => values?.email.includes(email);

  const handleRemoveNte = (id) => {
    setRemoveModel(true);
    setRemoveItem(id);
  };
  const handleRemoveNteCancel = () => {
    setRemoveModel(false);
  };
  const handleRemoveSavePopup = () => {
    setSaveValidationModel(false);
  };

  const removeNTEThreshold = async (attachmentId) => {
    console.log(removeItem);
    const config = {
      method: "DELETE",
      url: DELETE_NTE_DETAILS,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({ nteId: removeItem })),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        showToast("The threshold has been successfully removed.", "success");
        setRemoveModel(false);
        setRemoveItem("");
        setEditNTEvalues(false);
        setAddNewNTE(false);
        getprojectDetails();
        if (page > 1 && editPaginatedData?.length === 1) {
          // If there was only one item on the current page, move to the previous page
          setPage(page - 1);
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v?.message, "error");
      }
    }
  };

  const [visibleEmails, setVisibleEmails] = useState(5); // Number of initially visible emails

  console.log(visibleEmails, "visibleeeeeeeeee", values?.email?.length);

  const handleShowMore = () => {
    setVisibleEmails((prev) => prev + 5); // Show 5 more emails on each click
  };

  const handleShowLess = () => {
    setVisibleEmails(5); // Reset to initial view
    setIsHovered(false);
  };

  // const handleSort = (property) => {
  //   const isAsc = orderBy === property && orderDirection === "asc";

  //   if (orderBy === property && orderDirection === "desc") {
  //     // Reset sorting if already descending
  //     setOrderDirection("");
  //     setOrderBy("");
  //   } else {
  //     // Toggle between ascending and descending
  //     setOrderDirection(isAsc ? "desc" : "asc");
  //     setOrderBy(property);
  //   }
  //   setPage(1);

  //   // Reset the page to the first page when sorting changes
  // };
  const handleSort = (property) => {
    const isAsc = orderBy === property && orderDirection === "asc";

    const newOrder = isAsc ? "desc" : "asc";
    setOrderDirection(newOrder);
    setOrderBy(property);
    setPage(1);

    // Reset the page to the first page when sorting changes
  };

  const sortedDetails = [...NTEDetails].sort((a, b) => {
    if (!orderBy) return 0;

    // Handle sorting for numbers and strings
    let valueA = a[orderBy] || "";
    let valueB = b[orderBy] || "";

    // If the field is "WarningMeter", parse the value as a number for correct sorting
    if (orderBy === "WarningMeter") {
      valueA = parseFloat(valueA);
      valueB = parseFloat(valueB);
    } else {
      // Convert other fields to lowercase for string comparison
      valueA = String(valueA).toLowerCase();
      valueB = String(valueB).toLowerCase();
    }

    // Perform the sorting based on order direction
    if (orderDirection === "asc") {
      return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
    }
    return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
  });

  const getBrokerSortIcon = (orderByValue) => {
    console.log(orderByValue, orderBy, orderDirection, "kjsdjhuiwyiuyowyeyo ");
    if (orderBy === orderByValue) {
      return orderDirection === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const paginatedData = sortedDetails.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  const editPaginatedData = values?.NTEDetails?.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  const hasChanges = values?.NTEDetails?.some((nteDetail) => {
    const matchingDetail = NTEDetails.find(
      (detail) => detail.ID === nteDetail.ID
    );
    // Return true only if there's a mismatch between the original and current values
    return (
      matchingDetail &&
      (matchingDetail?.WarningMeter != nteDetail?.WarningMeter ||
        matchingDetail?.Description != nteDetail?.Description)
    );
  });

  // Convert the comma-separated emails into an array
  const projectEmails = projectDetails[0]?.Emails
    ? projectDetails[0]?.Emails.split(",").map((email) => email.trim())
    : [];

  // Check if any email has changed
  const emailChanges = projectEmails?.some((email) => {
    return !values?.email?.includes(email); // Check if email is not found in original list
  });

  const hasChangesemail =
    emailChanges || values?.email?.length !== projectEmails.length;

  console.log(
    hasChanges,
    "hasChangesthresholdChanges888888",
    values?.nteAmount == projectDetails[0]?.NTEAmount,
    hasChangesemail,
    projectEmails,
    values?.email
  );

  const handleEditSaveClick = async () => {
    console.log(
      email,
      email?.length,
      "971893474893984",
      values?.email?.length == 0
    );
    // Check if email exists and has a length greater than 0
    if (email?.length == 0 && values?.email?.length == 0) {
      setErrorTextEmail("Atleast one email is required.");
    } else if (email?.length > 0 && email != "") {
      setErrorTextEmail(
        "Email recipient not added. Please click 'Add' to proceed."
      );
    } else if (
      !hasChanges &&
      values?.nteAmount == projectDetails[0]?.NTEAmount &&
      !hasChangesemail
    ) {
      showToast(
        "No changes detected. Please make changes before saving.",
        "error"
      );
    } else {
      const payload = generatePayload(values, projectDetails, NTEDetails);
      try {
        // Validate using the validationSchema1 directly
        await validationSchema1.validate(values, { abortEarly: false });

        // If validation is successful, proceed to save the values
        // hanldeUpsertNTEDeatils(values, "", "Edit");
        if (
          payload?.details?.length > 0 ||
          payload?.thresholdDetails?.length > 0
        ) {
          setSavePopupMessage(payload);
          setTimeout(() => {
            setSaveValidationModel(true);
          }, 0);
        } else {
          hanldeUpsertNTEDeatils(values, "", "Edit");
        }
        console.log("Api_CALLED");
      } catch (validationErrors) {
        // If validation fails, validationErrors will contain the error details
        console.log("Validation failed:", validationErrors.inner);
        // setErrorTextEmail(
        //   "Email recipient not added. Please click 'Add' to proceed."
        // );
        // const firstError = validationErrors.inner[0];
        // if (firstError) {
        //   showToast(firstError.message, "error");
        // }
        // Optionally, handle the case where validation fails (e.g., highlight invalid fields)
      }
    }
  };

  const handleSaveConfirm = () => {
    hanldeUpsertNTEDeatils(values, "", "Edit");
  };

  return (
    <>
      {!values?.IsNTEEnabled ? (
        <Box className="secound-bg-box user-log">
          <Stack
            sx={{ mb: 2 }}
            direction={{ xs: "column", sm: "row", md: "row" }}
            alignItems={{ xs: "baseline", sm: "center", md: "center" }}
            justifyContent="space-between"
          >
            <Typography
              sx={{ marginBottom: "0px !important" }}
              className="customer-title"
              variant="h6"
              style={{ display: "flex", gap: "1rem" }}
            >
              NTE (Not to Exceed)
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <AntSwitch
                  checked={values?.IsNTEEnabled}
                  inputProps={{ "aria-label": "ant design" }}
                  onClick={handleToggleChange}
                  disabled={!locationList}
                />
              </Stack>
            </Typography>
          </Stack>
          <Grid container>
            <Box
              sx={{
                textAlign: "center",
                width: "100%",
                background: "#fff",
                marginTop: "15px",
                borderRadius: "5px",
              }}
            >
              <img
                style={{ width: "100%", maxWidth: "326px" }}
                src={ToggleEnableImage}
              />
              <p
                style={{ marginTop: "15px", marginBottom: "50px" }}
                className="no-data-text"
              >
                Turn on <span style={{ color: "#58A84A" }}>NTE</span> to track
                exceedances and receive alerts.
              </p>
            </Box>
          </Grid>
        </Box>
      ) : !editNTEvalues ? (
        <>
          <Box sx={{ mt: "12px" }} className="bg-box">
            <Stack
              sx={{ mb: 2 }}
              direction={{ xs: "column", sm: "row", md: "row" }}
              alignItems={{ xs: "baseline", sm: "center", md: "center" }}
              justifyContent="space-between"
            >
              <Typography
                sx={{ marginBottom: "0px !important" }}
                className="customer-title"
                variant="h6"
                style={{ display: "flex", gap: "1rem" }}
              >
                NTE (Not to Exceed)
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ alignItems: "center" }}
                >
                  <AntSwitch
                    checked={values?.IsNTEEnabled}
                    inputProps={{ "aria-label": "ant design" }}
                    onClick={handleToggleChange}
                  />
                </Stack>
              </Typography>{" "}
              {values?.IsNTEEnabled && (
                <Stack direction="row" spacing={1}>
                  {/* Add New Threshold Icon */}
                  <Tooltip title="Add New Threshold" arrow>
                    <span
                      className={"active-icon"}
                      style={{ cursor: "pointer" }}
                      onClick={openAddNewNTE}
                    >
                      <span className="material-symbols-outlined">add</span>
                    </span>
                  </Tooltip>

                  {/* Edit Icon */}

                  {NTEDetails?.length > 0 && (
                    <Tooltip title="Edit" arrow>
                      <span
                        className={"active-icon"}
                        style={{
                          cursor: values?.IsNTEEnabled
                            ? "pointer"
                            : "not-allowed",
                        }}
                        onClick={
                          values?.IsNTEEnabled ? opeEditNTEValues : () => {}
                        }
                      >
                        <span className="material-symbols-outlined">edit</span>
                      </span>
                    </Tooltip>
                  )}
                </Stack>
              )}
            </Stack>
            <Grid
              container
              sx={{
                background: "#f9fafb",
                padding: "5px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* Left Side Content */}
              <Grid item xs={12} md={8}>
                <p
                  style={{
                    padding: "3px",
                    fontSize: "14px",
                    fontWeight: 500,
                    paddingLeft: "15px",
                  }}
                >
                  Project Budget (NTE Amount):{" "}
                  <Input
                    disabled //non Editable
                    sx={{ maxWidth: "12rem", marginLeft: "15px" }}
                    className="dollar-field"
                    name="nteAmount"
                    id="nteAmount"
                    value={values?.nteAmount || ""}
                    placeholder="Enter NTE Amount"
                    startAdornment={
                      <InputAdornment position="start">
                        <span className="dollar-icon">$</span>
                      </InputAdornment>
                    }
                  />
                </p>
                <p
                  style={{
                    padding: "3px",
                    fontSize: "14px",
                    fontWeight: 500,
                    paddingLeft: "15px",
                  }}
                >
                  Current Billing Amount:{" "}
                  <Box
                    sx={{
                      display: "inline-block",
                      cursor: "pointer",
                      marginBottom: "16px",
                      width: "-webkit-fill-available",
                      maxWidth: "200px",
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      sx={{
                        borderRadius: "5px",
                        border:
                          "1px solid var(--Foundation-Grey-grey-50, #ededed)",
                        padding: "0px 14px",
                        height: "40px",
                        background: "#f6f7f9",
                        cursor: "pointer",
                        maxWidth: "190px",
                        marginLeft: "3.9rem",
                        width: "100%",
                      }}
                      onClick={() => {
                        localStorage.setItem("LOG_SIDE_INDEX", "4");

                        const customerId = projectDetails?.[0]?.CustomerID;
                        const projectId = projectDetails?.[0]?.ProjectID;

                        const url = `/billing-review?cusId=${customerId}&projId=${projectId}`;
                        window.open(url, "_blank");
                      }}
                    >
                      <span
                        style={{ fontSize: "16px", paddingRight: "5px" }}
                        className="dollar-icon"
                      >
                        $
                      </span>
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ mx: 2, borderColor: "#ccc" }}
                      />
                      <Tooltip title="Billing review" placement="top">
                        <Typography
                          sx={{
                            textDecoration: "underline",
                            color: "#178bf3",
                            fontSize: "13px",
                          }}
                        >
                          {values?.totalValue
                            ? parseFloat(values.totalValue).toFixed(2)
                            : "0.00"}
                        </Typography>
                      </Tooltip>
                    </Stack>
                  </Box>
                </p>
                <Divider sx={{ width: "28rem", marginLeft: "13px" }} />
                <p
                  style={{
                    padding: "3px",
                    fontSize: "14px",
                    fontWeight: 500,
                    paddingLeft: "15px",
                    maxWidth: "30rem",
                  }}
                >
                  Email Recipients:
                  <br />
                  <span
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "5px",
                      marginTop: "5px",
                    }}
                  >
                    {values?.email?.length > 0 ? (
                      <>
                        {values?.email
                          ?.slice(0, visibleEmails)
                          .map((val, index) => (
                            <span
                              key={index}
                              style={{
                                backgroundColor: "#e3f2fd", // Light blue background
                                padding: "5px 10px",
                                borderRadius: "5px",
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "#0d47a1", // Dark blue text
                              }}
                            >
                              {val}
                            </span>
                          ))}
                        {values?.email?.length > visibleEmails &&
                          visibleEmails !== values?.email?.length && (
                            <span
                              onClick={handleShowMore}
                              style={{
                                backgroundColor: isHovered
                                  ? "#00ffff"
                                  : "#e3f2fd",
                                color: "#0d47a1",
                                padding: "5px 10px",
                                borderRadius: "5px",
                                fontSize: "12px",
                                fontWeight: 500,
                                cursor: "pointer",
                              }}
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                            >
                              ..+{values?.email?.length - visibleEmails}
                            </span>
                          )}

                        {values?.email?.length > 5 &&
                          visibleEmails >= values?.email?.length && (
                            <span
                              onClick={handleShowLess}
                              style={{
                                backgroundColor: "#ffcccb", // Light red background to highlight
                                color: "#616161", // Dark gray text
                                padding: "6px 10px",
                                borderRadius: "5px",
                                fontSize: "12px",
                                fontWeight: 600, // Slightly bolder font for emphasis
                                cursor: "pointer",
                                marginTop: "auto",
                                marginBottom: "auto",
                              }}
                            >
                              Show less
                            </span>
                          )}
                      </>
                    ) : (
                      "-- No email found --"
                    )}
                  </span>
                </p>
              </Grid>

              {/* Right Side Content */}
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Speedometer id="dynamicSpeedometer" value={NTEPercentage()} />
                <Typography
                  sx={{
                    marginTop: "-43px !important",
                    fontSize: "10px",
                    fontWeight: 500,
                  }}
                >
                  Billing Threshold (%)
                </Typography>{" "}
                {/* Add margin for spacing */}
              </Grid>
            </Grid>

            <TableContainer
              className="project-broker-table NTE-table"
              sx={{ boxShadow: "none", marginTop: "10px" }}
              component={Paper}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {values?.IsNTEEnabled && <TableCell>No.</TableCell>}
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === "Description"}
                        direction={
                          orderBy === "Description" ? orderDirection : "asc"
                        }
                        onClick={() => handleSort("Description")}
                        IconComponent={() => getBrokerSortIcon("Description")}
                        style={
                          orderBy === "Description" ? { color: "#007fff" } : {}
                        }
                      >
                        Alert Name
                      </TableSortLabel>
                    </TableCell>
                    <TableCell sx={{ minWidth: "125px" }}>
                      <TableSortLabel
                        active={orderBy === "WarningMeter"}
                        direction={
                          orderBy === "WarningMeter" ? orderDirection : "asc"
                        }
                        onClick={() => handleSort("WarningMeter")}
                        IconComponent={() => getBrokerSortIcon("WarningMeter")}
                        style={
                          orderBy === "WarningMeter" ? { color: "#007fff" } : {}
                        }
                      >
                        Threshold (%)
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.map((item, index) => {
                    const serialNumber = (page - 1) * rowsPerPage + index + 1;
                    return (
                      // Add the return statement here
                      <TableRow key={index}>
                        <TableCell>{serialNumber}.</TableCell>
                        <TableCell>
                          <span style={{ lineBreak: "anywhere" }}>
                            {item?.Description || "--"}
                          </span>
                        </TableCell>
                        <TableCell>
                          {Number(item?.WarningMeter).toFixed(2)}%
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" spacing={1}>
                            <span
                              className={
                                values?.IsNTEEnabled && NTEDetails?.length > 1
                                  ? "delete-icon"
                                  : "disable-delete-icon"
                              }
                              style={{
                                cursor:
                                  values?.IsNTEEnabled && NTEDetails?.length > 1
                                    ? "pointer"
                                    : "not-allowed",
                                pointerEvents:
                                  values?.IsNTEEnabled && NTEDetails?.length > 1
                                    ? "auto"
                                    : "none", // Disable click events
                              }}
                              onClick={() => {
                                if (
                                  values?.IsNTEEnabled &&
                                  NTEDetails?.length > 1 &&
                                  !editNTEvalues
                                ) {
                                  handleRemoveNte(item?.ID);
                                }
                              }}
                            >
                              <span className="material-symbols-outlined">
                                delete
                              </span>
                            </span>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              {NTEDetails?.length == 0 ? (
                <Box
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    background: "#fff",
                    marginTop: "25px",
                    borderRadius: "5px",
                  }}
                >
                  <img
                    style={{ maxWidth: "326px", width: "100%" }}
                    src={customerNodata}
                  />

                  <Typography
                    className="no-data-text"
                    style={{ marginTop: "25px" }}
                  >
                    Please complete the{" "}
                    <span style={{ color: "green" }}>Threshold</span> setup to
                    start receiving alerts.
                  </Typography>
                </Box>
              ) : (
                ""
              )}

              {/* {BokerPaginatedData &&
        BokerPaginatedData.filter((rec) => rec.Active == true).length >
          0 ? null : (
          <Box sx={{ textAlign: "center" }}>
            <img src={brokerNodata} />
          </Box>
        )} */}
              <br />
            </TableContainer>
            {sortedDetails?.length > 0 && (
              <Pagination
                // variant="outlined"
                shape="rounded"
                count={Math.ceil(NTEDetails?.length / rowsPerPage)}
                page={page}
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: () => (
                        <Icon className="material-symbols-outlined">
                          keyboard_backspace
                        </Icon>
                      ),
                      next: () => (
                        <Icon className="material-symbols-outlined">east</Icon>
                      ),
                    }}
                    {...item}
                  />
                )}
                onChange={handlePageChange}
                sx={{ mt: "13.5px", display: "flex", justifyContent: "end" }}
                // sx={{ mt: "13.5px", display: "flex", justifyContent: "center" }}
              />
            )}
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ mt: "12px" }} className="bg-box">
            <Stack
              sx={{ mb: 2 }}
              direction={{ xs: "column", sm: "row", md: "row" }}
              alignItems={{ xs: "baseline", sm: "center", md: "center" }}
              justifyContent="space-between"
            >
              <Typography
                sx={{ marginBottom: "0px !important" }}
                className="customer-title"
                variant="h6"
                style={{ display: "flex", gap: "1rem" }}
              >
                NTE (Not to Exceed)
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ alignItems: "center" }}
                >
                  <AntSwitch
                    checked={values?.IsNTEEnabled}
                    inputProps={{ "aria-label": "ant design" }}
                    onClick={handleToggleChange1}
                  />
                </Stack>
              </Typography>
              {/* <Button
            sx={{ mt: { xs: "-10px" } }}
            startIcon={<span class="material-symbols-outlined">add</span>}
            className={
              // locationList && locationList.length == 0
              //   ? "default-btn"
              //   :
              "primary-btn"
            }
            variant="contained"
            color="success"
            onClick={openAddNewNTE}
            //   disabled={locationList && locationList.length == 0}
          >
            Add
          </Button> */}
              {editNTEvalues && (
                <Grid sx={{ display: "flex", gap: "5px" }}>
                  <Button
                    className={
                      buttonLoading
                        ? // (!hasChanges &&
                          //   values?.nteAmount == projectDetails[0]?.NTEAmount &&
                          //   !hasChangesemail)
                          "disable-filter-btn"
                        : "primary-btn"
                    }
                    onClick={handleEditSaveClick}
                    disabled={buttonLoading}
                  >
                    {buttonLoading && (
                      <CircularProgress
                        color={"inherit"}
                        size={10}
                        sx={{ marginRight: "3px" }}
                      />
                    )}
                    Save
                  </Button>
                  <Button
                    className="cancel-btn"
                    onClick={handleClickCancel}
                    disabled={buttonLoading}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}
            </Stack>
            <Grid
              container
              sx={{
                background: "#f9fafb",
                padding: "15px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* Left Side Content */}
              <Grid item xs={12} md={8}>
                <div
                  style={{
                    paddingLeft: "15px",
                    padding: "3px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <label style={{ fontSize: "14px", fontWeight: 500 }}>
                    {" "}
                    {/* Editable NTE Amount */}
                    Project Budget (NTE Amount):
                  </label>
                  <Box>
                    <Input
                      sx={{
                        maxWidth: "12rem",
                        marginLeft: "10px",
                        backgroundColor: "white !important",
                        borderColor:
                          !errors?.nteAmount &&
                          values?.nteAmount != projectDetails[0]?.NTEAmount
                            ? "yellow !important"
                            : "inherit",
                      }}
                      className="dollar-field"
                      name="nteAmount"
                      id="nteAmount"
                      value={values?.nteAmount}
                      placeholder="Enter NTE Amount"
                      onChange={(e) => {
                        const { value } = e.target;
                        // Allow only numbers with up to 2 decimal places
                        const validValue = value.match(/^\d*(\.\d{0,2})?$/)
                          ? value
                          : values.nteAmount;
                        setFieldValue("nteAmount", validValue); // Update Formik's state
                      }}
                      onBlur={handleBlur}
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="dollar-icon">$</span>
                        </InputAdornment>
                      }
                      error={touched.nteAmount && Boolean(errors.nteAmount)} // Apply error styling if the field is touched and there's an error
                      helperText={touched.nteAmount && errors.nteAmount}
                    />
                    <FormHelperText error={true} sx={{ ml: "10px" }}>
                      {errors?.nteAmount}
                    </FormHelperText>
                  </Box>
                </div>

                <p
                  style={{
                    padding: "3px",
                    fontSize: "14px",
                    fontWeight: 500,
                    // paddingLeft: "15px",
                  }}
                >
                  Current Billing Amount:{" "}
                  <Box
                    sx={{
                      display: "inline-block",
                      cursor: "pointer",
                      marginBottom: "16px",
                      width: "-webkit-fill-available",
                      maxWidth: "200px",
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      sx={{
                        borderRadius: "5px",
                        border:
                          "1px solid var(--Foundation-Grey-grey-50, #ededed)",
                        padding: "0px 14px",
                        height: "40px",
                        background: "#f6f7f9",
                        cursor: "pointer",
                        maxWidth: "190px",
                        marginLeft: "3.9rem",
                        width: "100%",
                      }}
                      onClick={() => {
                        localStorage.setItem("LOG_SIDE_INDEX", "4");

                        const customerId = projectDetails?.[0]?.CustomerID;
                        const projectId = projectDetails?.[0]?.ProjectID;

                        const url = `/billing-review?cusId=${customerId}&projId=${projectId}`;
                        window.open(url, "_blank");
                      }}
                    >
                      <span
                        style={{ fontSize: "16px", paddingRight: "5px" }}
                        className="dollar-icon"
                      >
                        $
                      </span>
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ mx: 2, borderColor: "#ccc" }}
                      />
                      <Tooltip title="Billing review" placement="top">
                        <Typography
                          sx={{
                            textDecoration: "underline",
                            color: "#178bf3",
                            fontSize: "13px",
                          }}
                        >
                          {values?.totalValue
                            ? parseFloat(values.totalValue).toFixed(2)
                            : "0.00"}
                        </Typography>
                      </Tooltip>
                    </Stack>
                  </Box>
                </p>
                <Divider
                  sx={{ width: "28rem", margin: "10px", marginLeft: "0px" }}
                />

                {/* Editable Email Recipients */}
                <div
                  style={{
                    paddingLeft: "15px",
                    padding: "3px",
                    maxWidth: "30rem",
                  }}
                >
                  <label style={{ fontSize: "14px", fontWeight: 500 }}>
                    Email Recipients:
                  </label>
                  <Box
                    className="chip-email"
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ marginTop: "10px" }}
                  >
                    <TextField
                      sx={{
                        flex: 1,
                        maxWidth: "22rem",
                        backgroundColor: "white !important",
                      }}
                      placeholder="Enter email address"
                      value={email.trim()} // Automatically trim spaces while displaying
                      onChange={(e) => {
                        const value = e.target.value.replace(/\s/g, ""); // Remove spaces dynamically
                        setEmail(value);
                        setErrorTextEmail("");
                        setFieldValue("isTyping", true);
                      }} // Remove spaces during input
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          setFieldValue("isTyping", true);
                          e.preventDefault();
                          handleAddEmail();
                        }
                      }}
                      onBlur={() => {
                        setFieldValue("isTyping", false); // Reset isTyping on blur
                        setFieldTouched("email", true); // Mark field as touched
                      }}
                      // error={
                      //   emails?.length == 0 && values?.email?.length == 0
                      // }
                      // helperText={
                      //   emails?.length == 0 && values?.email?.length == 0
                      //     ? "At least one email required."
                      //     : ""
                      // }
                      InputProps={{
                        endAdornment: (
                          <IconButton
                            onClick={handleAddEmail}
                            color={"success"}
                            aria-label={
                              isValidEmail(email)
                                ? "Add email"
                                : "Invalid email"
                            }
                          >
                            {/* {isValidEmail(email) ? (
                              <CheckCircleIcon />
                            ) : ( */}
                            <AddIcon titleAccess="Add Email" />
                            {/* )} */}
                          </IconButton>
                        ),
                      }}
                    />
                    {/* {isValidEmail(email) && !emailExists(email) && (
                      <IconButton
                        onClick={handleAddEmail}
                        color="success"
                        aria-label="Add email"
                      >
                        <CheckCircleIcon />
                      </IconButton>
                    )} */}
                  </Box>
                  <FormHelperText error={true}>
                    {errorTextEmail}{" "}
                  </FormHelperText>
                  {/* Display List of Emails */}
                  <Box
                    className="chip-box"
                    sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}
                  >
                    {values?.email?.slice(0, visibleEmails).map((email) => (
                      <Chip
                        key={email}
                        label={email}
                        onDelete={() => handleRemoveEmail(email)}
                        deleteIcon={<CloseIcon />}
                        color="primary"
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "8px !important",
                          backgroundColor: "#e3f2fd",
                          color: "#0d47a1",
                          "& .MuiChip-deleteIcon": {
                            color: "#0d47a1", // Default color
                            "&:hover": {
                              color: "#d32f2f", // Hover color, change as needed
                            },
                          },
                          maxWidth: "200px",
                        }}
                      />
                    ))}
                    {values?.email?.length > visibleEmails && (
                      <Chip
                        label={`...+${values?.email?.length - visibleEmails}`}
                        onClick={handleShowMore}
                        color="secondary"
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "8px !important",
                          backgroundColor: "#e3f2fd",
                          color: "#0d47a1",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "#00ffff",
                            color: "#0d47a1",
                            fontSize: "12px",
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    {values?.email?.length > 5 &&
                      visibleEmails >= values?.email?.length && (
                        // <Chip
                        //   label="Show less"
                        //   onClick={handleShowLess}
                        //   color="default"
                        //   style={{
                        //     fontSize: "12px",
                        //     fontWeight: 500,
                        //     borderRadius: "8px !important",
                        //     backgroundColor: "#eeeeee", // Light gray background
                        //     color: "#616161", // Dark gray text
                        //     cursor: "pointer",
                        //   }}
                        // />
                        <span
                          onClick={handleShowLess}
                          style={{
                            backgroundColor: "#ffcccb",
                            color: "#616161",
                            padding: "6px 10px",
                            borderRadius: "5px",
                            fontSize: "12px",
                            fontWeight: 600,
                            cursor: "pointer",
                            marginTop: "auto",
                            marginBottom: "auto",
                          }}
                        >
                          Show less
                        </span>
                      )}
                  </Box>
                </div>
              </Grid>

              {/* Right Side Content */}
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Speedometer id="dynamicSpeedometer" value={NTEPercentage()} />
                <Typography
                  sx={{
                    marginTop: "-43px !important",
                    fontSize: "10px",
                    fontWeight: 500,
                  }}
                >
                  Billing Threshold (%)
                </Typography>{" "}
              </Grid>
            </Grid>

            <TableContainer
              className="project-broker-table"
              sx={{ boxShadow: "none", marginTop: "10px" }}
              component={Paper}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {values?.IsNTEEnabled && <TableCell>No.</TableCell>}
                    <TableCell>
                      {/* <TableSortLabel
                        active={locationOrderBy === "alertName"}
                        direction={
                          locationOrderBy === "alertName"
                            ? locationOrder
                            : "asc"
                        }
                        onClick={() =>
                          handleBrokerSortRequest("alertName")
                        }
                        // IconComponent={() =>
                        //   getBrokerSortIcon("alertName")
                        // }
                        style={
                          brokerOrderBy === "alertName"
                            ? { color: "#007fff" }
                            : {}
                        }
                      > */}
                      Alert Name
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell>Threshold (%)</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(editPaginatedData || []).map((row, index) => {
                    const actualIndex = (page - 1) * rowsPerPage + index; // Calculate the actual index in the full dataset
                    const serialNumber = actualIndex + 1; // Use the actual index for serial number

                    // Highlight condition for Description and WarningMeter
                    const isDescriptionModified = changedFields.has(
                      `description-${actualIndex}`
                    );
                    const isWarningMeterModified = changedFields.has(
                      `warningMeter-${actualIndex}`
                    );

                    const originalDescription =
                      NTEDetails?.[actualIndex]?.Description || "";
                    const originalWarningMeter =
                      NTEDetails?.[actualIndex]?.WarningMeter || "";

                    console.log(isDescriptionModified, "issssssssssssssssss");

                    const handleDescriptionChange = (e) => {
                      const { value } = e.target;
                      if (value.length <= 200) {
                        const updatedNTEDetails = [
                          ...(values.NTEDetails || []),
                        ];
                        updatedNTEDetails[actualIndex] = {
                          ...updatedNTEDetails[actualIndex],
                          Description: value,
                        };
                        setFieldValue("NTEDetails", updatedNTEDetails);

                        // Track changes
                        setChangedFields((prev) => {
                          const newSet = new Set(prev);
                          if (value === originalDescription) {
                            newSet.delete(`description-${actualIndex}`); // Remove if reverted to original
                          } else {
                            newSet.add(`description-${actualIndex}`);
                          }
                          return newSet;
                        });
                      }
                    };

                    // WarningMeter Change Handler
                    const handleWarningMeterChange = (e) => {
                      const { value } = e.target;
                      const regex =
                        /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{0,2})?|\.([0-9]{1,2})?)?$/; // Allow decimal numbers starting with "."

                      // Allow backspace or other key presses if they match the regex
                      if (regex.test(value) || value === "") {
                        const updatedNTEDetails = [
                          ...(values.NTEDetails || []),
                        ];

                        // Update the WarningMeter value
                        updatedNTEDetails[actualIndex] = {
                          ...updatedNTEDetails[actualIndex],
                          WarningMeter: value,
                        };

                        setFieldValue("NTEDetails", updatedNTEDetails);

                        // Track changes based on the original value
                        setChangedFields((prev) => {
                          const newSet = new Set(prev);

                          // Check if the value has reverted to the original value
                          if (
                            value === originalWarningMeter ||
                            value.trim() === ""
                          ) {
                            newSet.delete(`warningMeter-${actualIndex}`); // Remove from the set if it matches the original or is empty
                          } else {
                            newSet.add(`warningMeter-${actualIndex}`);
                          }

                          return newSet;
                        });
                      }
                    };

                    return (
                      <TableRow key={index}>
                        {values?.IsNTEEnabled && (
                          <TableCell>{serialNumber}.</TableCell>
                        )}
                        <TableCell>
                          <TextField
                            fullWidth
                            variant="standard"
                            size="small"
                            value={row.Description}
                            placeholder="Enter Alert Name"
                            // onChange={(e) => {
                            //   const { value } = e.target;
                            //   if (value.length <= 200) {
                            //     const updatedNTEDetails = [
                            //       ...(values.NTEDetails || []),
                            //     ];
                            //     updatedNTEDetails[actualIndex] = {
                            //       ...updatedNTEDetails[actualIndex],
                            //       Description: value,
                            //     };
                            //     setFieldValue("NTEDetails", updatedNTEDetails);
                            //     setChangedFields((prev) =>
                            //       new Set(prev).add(
                            //         `description-${actualIndex}`
                            //       )
                            //     ); // Track as changed
                            //   }
                            // }}
                            onChange={handleDescriptionChange}
                            InputProps={{
                              disableUnderline: false,
                              style: {
                                border:
                                  focusedIndex === actualIndex
                                    ? "1px solid #58a84a" // Green border when active
                                    : row.Description !== "" &&
                                      isDescriptionModified
                                    ? "1px solid yellow" // Yellow border when modified
                                    : "", // No border when neither condition is met
                              },
                            }}
                            onFocus={() => setFocusedIndex(actualIndex)} // Set focus state to this row index
                            onBlur={() => setFocusedIndex(null)} // Clear focus when the input loses focus
                            inputProps={{
                              // disableUnderline: false,
                              maxLength: 200, // Prevent additional characters from being typed
                            }}
                            error={row.Description == ""}
                            helperText={
                              row.Description == ""
                                ? "Alert Name is required."
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            fullWidth
                            variant="standard"
                            size="small"
                            value={row.WarningMeter || ""}
                            placeholder="Enter Threshold (%)"
                            onChange={handleWarningMeterChange}
                            onFocus={() => setFocusedIndexWarning(actualIndex)} // Set focus state to this row index
                            onBlur={() => setFocusedIndexWarning(null)} // Clear focus when the input loses focus
                            // onChange={(e) => {
                            //   const { value } = e.target;
                            //   // Regex to allow numbers between 0 and 100 with up to two decimal places
                            //   const regex =
                            //     /^(100(\.00?)?|(\d{1,2})(\.\d{0,2})?)?$/;

                            //   if (regex.test(value)) {
                            //     const updatedNTEDetails = [
                            //       ...(values.NTEDetails || []),
                            //     ];
                            //     updatedNTEDetails[actualIndex] = {
                            //       ...updatedNTEDetails[actualIndex],
                            //       WarningMeter: value,
                            //     };
                            //     setFieldValue("NTEDetails", updatedNTEDetails);
                            //     setChangedFields((prev) => new Set(prev).add(`warningMeter-${actualIndex}`));
                            //   }
                            // }}
                            InputProps={{
                              disableUnderline: false,
                              style: {
                                border:
                                  focusedIndexWarning === actualIndex
                                    ? "1px solid #58a84a" // Green border when active
                                    : !(
                                        !row.WarningMeter ||
                                        row.WarningMeter === "0" ||
                                        row.WarningMeter === "00" ||
                                        row.WarningMeter === "0.00" ||
                                        row.WarningMeter === "00.0" ||
                                        row.WarningMeter === "00.00" ||
                                        row.WarningMeter === "0.0" ||
                                        row.WarningMeter === "0." ||
                                        row.WarningMeter === ".0" ||
                                        row.WarningMeter === ".00" ||
                                        row.WarningMeter === "."
                                      ) && isWarningMeterModified
                                    ? "1px solid yellow" // Apply yellow border when modified
                                    : "",
                              },
                            }}
                            error={
                              !row.WarningMeter ||
                              row.WarningMeter == "0" ||
                              row.WarningMeter == "00" ||
                              row.WarningMeter === "00.0" ||
                              row.WarningMeter === "00.00" ||
                              row.WarningMeter == "0.00" ||
                              row.WarningMeter == "0.0" ||
                              row.WarningMeter == "0." ||
                              row.WarningMeter == ".0" ||
                              row.WarningMeter == ".00" ||
                              row.WarningMeter == "."
                            }
                            helperText={
                              !row.WarningMeter
                                ? "Threshold (%) is required."
                                : row.WarningMeter == "0" ||
                                  row.WarningMeter == "0.00" ||
                                  row.WarningMeter == "00" ||
                                  row.WarningMeter == "0.0" ||
                                  row.WarningMeter === "00.0" ||
                                  row.WarningMeter == "0." ||
                                  row.WarningMeter == ".0" ||
                                  row.WarningMeter === "00.00" ||
                                  row.WarningMeter == ".00" ||
                                  row.WarningMeter == "."
                                ? "Threshold (%) must be greater than '0'"
                                : ""
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" spacing={1}>
                            <span
                              className={
                                // values?.IsNTEEnabled && NTEDetails?.length > 1
                                //   ? "delete-icon"
                                //   :
                                "disable-delete-icon"
                              }
                              style={{
                                cursor:
                                  // values?.IsNTEEnabled && NTEDetails?.length > 1
                                  //   ? "pointer"
                                  //   :
                                  "not-allowed",
                                pointerEvents:
                                  // values?.IsNTEEnabled && NTEDetails?.length > 1
                                  //   ? "auto"
                                  //   :
                                  "none", // Disable click events
                              }}
                              // onClick={() => {
                              //   if (
                              //     values?.IsNTEEnabled &&
                              //     NTEDetails?.length > 1
                              //   ) {
                              //     handleRemoveNte(row?.ID);
                              //   }
                              // }}
                            >
                              <span className="material-symbols-outlined">
                                delete
                              </span>
                            </span>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              {NTEDetails?.length == 0 ? <NoRecordFound /> : ""}

              {/* {BokerPaginatedData &&
        BokerPaginatedData.filter((rec) => rec.Active == true).length >
          0 ? null : (
          <Box sx={{ textAlign: "center" }}>
            <img src={brokerNodata} />
          </Box>
        )} */}
              <br />
            </TableContainer>
            {editPaginatedData?.length > 0 && (
              <Pagination
                // variant="outlined"
                shape="rounded"
                count={Math.ceil(values?.NTEDetails?.length / rowsPerPage)}
                page={page}
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: () => (
                        <Icon className="material-symbols-outlined">
                          keyboard_backspace
                        </Icon>
                      ),
                      next: () => (
                        <Icon className="material-symbols-outlined">east</Icon>
                      ),
                    }}
                    {...item}
                  />
                )}
                onChange={handlePageChange}
                sx={{ mt: "13.5px", display: "flex", justifyContent: "end" }}
                // sx={{ mt: "13.5px", display: "flex", justifyContent: "center" }}
              />
            )}
          </Box>
        </>
      )}
      {addNewNTE ? (
        <Dialog
          className="user-filter-popup cst-filter"
          sx={{ width: "100%" }}
          fullScreen={fullScreen}
          open={addNewNTE}
          aria-labelledby="responsive-dialog-title"
          component={"form"}
          onSubmit={handleSubmit}
        >
          <Stack
            sx={{ p: "25px 34px" }}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography className="model-title">Add New Threshold</Typography>
          </Stack>
          <Box sx={{ p: "0px 34px 0px 34px" }}>
            <Stack
              direction="row"
              alignItems="baseline"
              justifyContent="space-between"
              spacing={3}
            >
              <FormControl sx={{ width: "100%" }} variant="standard">
                <p className="label">Project Budget (NTE Amount): </p>
                <Input
                  disabled={projectDetails[0]?.NTEAmount}
                  // sx={{ maxWidth: "12rem" }}
                  className="dollar-field"
                  name="nteAmount"
                  id="nteAmount"
                  value={values?.nteAmount || ""}
                  placeholder="Enter NTE Amount" //Add NTE Amount
                  onChange={(e) => {
                    const { value } = e.target;
                    // Allow only numbers with up to 2 decimal places
                    const validValue = value.match(/^\d*(\.\d{0,2})?$/)
                      ? value
                      : values.nteAmount;
                    setFieldValue("nteAmount", validValue); // Update Formik's state
                  }}
                  onBlur={handleBlur} // Mark as touched
                  inputProps={{
                    inputMode: "decimal", // Mobile-friendly numeric input
                    pattern: "[0-9]*[.,]?[0-9]{0,2}", // Regex for input validation
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <span className="dollar-icon">$</span>
                    </InputAdornment>
                  }
                />
                <FormHelperText
                  error={!!(errors.nteAmount && touched.nteAmount)}
                >
                  {errors.nteAmount && touched.nteAmount
                    ? errors.nteAmount
                    : ""}
                </FormHelperText>
              </FormControl>
              <FormControl sx={{ width: "100%" }} variant="standard">
                <p className="label">Alert Name:</p>
                <Input
                  name="alertName"
                  id="alertName"
                  value={values?.alertName || ""} // Bind Formik's value
                  placeholder="Enter Alert Name"
                  onChange={(e) => {
                    const { value } = e.target;

                    // Allow letters, spaces, and common special characters (., -, and _)
                    const isValid = /^[A-Za-z\s.,-_]*$/.test(value);

                    // Ensure the value contains at least one non-space character
                    const isNonEmpty = value.trim().length > 0;

                    // Ensure the value does not exceed 200 characters
                    if (value.length <= 200 && isNonEmpty) {
                      setFieldValue("alertName", value); // Update Formik's state
                    } else {
                      setFieldValue("alertName", "");
                    }
                  }}
                  onBlur={handleBlur} // Mark as touched
                  inputProps={{
                    maxLength: 200,
                  }}
                />
                <FormHelperText
                  error={
                    !!(
                      (errors.alertName && touched.alertName) ||
                      values.alertName?.length === 200
                    )
                  }
                >
                  {errors.alertName && touched.alertName
                    ? errors.alertName
                    : values.alertName?.length === 200
                    ? "You have reached the maximum character limit."
                    : ""}
                </FormHelperText>
              </FormControl>
            </Stack>
            <Stack
              sx={{ mb: "5px" }}
              direction="row"
              alignItems="flex-start"
              justifyContent="space-between"
              spacing={2}
            >
              <FormControl sx={{ width: "100%" }} variant="standard">
                <p className="label">Threshold (%):</p>
                <Input
                  name="threshold"
                  sx={{
                    maxWidth:
                      projectDetails[0]?.NTEAmount &&
                      projectDetails[0]?.NTEAmount != ("0" || "0.00")
                        ? "48%"
                        : "99%",
                  }}
                  id="threshold"
                  value={values.threshold || ""} // Bind Formik's value
                  placeholder="Enter Threshold (%)"
                  onChange={(e) => {
                    const { value } = e.target;

                    // Allow clearing the field explicitly
                    if (value === "") {
                      setFieldValue("threshold", "");
                      return;
                    }

                    // Validate and sanitize input
                    if (
                      /^(\.|100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{0,2})?|\.([0-9]{1,2})?)?$/.test(
                        value
                      ) &&
                      (value === "." || parseFloat(value) <= 100)
                    ) {
                      setFieldValue("threshold", value);
                    }
                  }}
                  onBlur={handleBlur} // Mark as touched
                  inputProps={{
                    inputMode: "decimal", // Mobile-friendly decimal keyboard
                  }}
                />

                <FormHelperText
                  error={!!(errors.threshold && touched.threshold)}
                >
                  {errors.threshold && touched.threshold
                    ? errors.threshold
                    : ""}
                </FormHelperText>
              </FormControl>

              {!projectDetails[0]?.NTEAmount && (
                <Box sx={{ width: "-webkit-fill-available" }}>
                  <FormControl
                    sx={{
                      width: "100%",
                      marginBottom: "0px !important",
                    }}
                    variant="outlined"
                  >
                    <p className="label">Email Recipients:</p>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      sx={{
                        paddingRight: "0px !important",
                        marginBottom: "0px !important",
                      }}
                    >
                      <TextField
                        sx={{
                          flex: 1,
                          maxWidth: "100%",
                          paddingRight: "0px !important",
                          overflowX: "auto", // Allows scrolling for long email addresses
                          marginBottom: "0px !important",
                        }}
                        placeholder="Enter email address"
                        value={email.trim()} // Automatically trim spaces while displaying
                        onChange={(e) => {
                          setEmail(e.target.value.trim());
                          setErrorTextEmail("");
                          setFieldValue("isTyping", true);
                        }} // Remove spaces during input
                        className="new-alert"
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            setFieldValue("isTyping", true);
                            e.preventDefault();
                            handleAddEmail();
                          }
                        }}
                        onBlur={() => {
                          setFieldValue("isTyping", false); // Reset isTyping on blur
                          setFieldTouched("email", true); // Mark field as touched
                        }}
                        // error={
                        //   (email.length > 0 && !isValidEmail(email)) ||
                        //   emailExists(email) ||
                        //   values?.email?.length === 0
                        // }
                        // helperText={
                        //   values?.email?.length === 0
                        //     ? "At least one email required."
                        //     : email.length > 0 && !isValidEmail(email)
                        //     ? "Invalid email address."
                        //     : emailExists(email)
                        //     ? "Email already exists."
                        //     : ""
                        // }
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              onClick={handleAddEmail}
                              color={"success"}
                              aria-label={
                                isValidEmail(email)
                                  ? "Add email"
                                  : "Invalid email"
                              }
                            >
                              {/* {isValidEmail(email) ? (
                                <CheckCircleIcon />
                              ) : ( */}
                              <AddIcon titleAccess="Add Email" />
                              {/* )} */}
                            </IconButton>
                          ),
                        }}
                      />
                    </Box>
                    <FormHelperText
                      sx={{
                        mt:
                          errorTextEmail || errors.email
                            ? "-17px !important"
                            : "-13px !important",
                      }}
                      error={true}
                    >
                      {touched.email && errors.email && !errorTextEmail
                        ? errors.email
                        : errorTextEmail}
                    </FormHelperText>
                  </FormControl>
                  <Box
                    className="chip-box"
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      mt: "-17px",
                    }}
                  >
                    {values?.email?.slice(0, visibleEmails).map((email) => (
                      <Chip
                        key={email}
                        label={email}
                        onDelete={() => handleRemoveEmail(email)}
                        deleteIcon={<CloseIcon />}
                        color="primary"
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "8px !important",
                          backgroundColor: "#e3f2fd",
                          color: "#0d47a1",
                          "& .MuiChip-deleteIcon": {
                            color: "#0d47a1", // Default color
                            "&:hover": {
                              color: "#d32f2f", // Hover color, change as needed
                            },
                          },
                        }}
                      />
                    ))}
                    {values?.email?.length > visibleEmails && (
                      <Chip
                        label={`...+${values?.email?.length - visibleEmails}`}
                        onClick={handleShowMore}
                        color="secondary"
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          borderRadius: "8px !important",
                          backgroundColor: "#e3f2fd",
                          color: "#0d47a1",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "#00ffff",
                            color: "#0d47a1",
                            fontSize: "12px",
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    {values?.email?.length > 5 &&
                      visibleEmails >= values?.email?.length && (
                        // <Chip
                        //   label="Show less"
                        //   onClick={handleShowLess}
                        //   color="default"
                        //   style={{
                        //     fontSize: "12px",
                        //     fontWeight: 500,
                        //     borderRadius: "8px !important",
                        //     cursor: "pointer",
                        //     backgroundColor: "#eeeeee", // Light gray background
                        //     color: "#616161", // Dark gray text
                        //   }}
                        // />
                        <span
                          onClick={handleShowLess}
                          style={{
                            backgroundColor: "#ffcccb", // Light gray background
                            color: "#616161", // Dark gray text
                            padding: "6px 10px",
                            borderRadius: "5px",
                            fontSize: "12px",
                            fontWeight: 500,
                            cursor: "pointer",
                            marginTop: "auto",
                            marginBottom: "auto",
                          }}
                        >
                          Show less
                        </span>
                      )}
                  </Box>
                </Box>
              )}
            </Stack>
          </Box>
          <DialogActions
            sx={{ justifyContent: "flex-start", p: "26px 34px", pt: "0px" }}
          >
            <Button
              className={buttonLoading ? "disable-filter-btn" : "filter-btn"}
              type="submit"
              disabled={buttonLoading}
            >
              {buttonLoading && (
                <CircularProgress
                  color={"inherit"}
                  size={10}
                  sx={{ marginRight: "3px" }}
                />
              )}
              Add
            </Button>
            <Button className="cancel-btn" onClick={handleClose}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        ""
      )}
      {removeModel && (
        <RemoveNTEthreshold
          open={removeModel}
          removeItem={removeItem}
          removeItemFuncConfirm={handleRemoveNteCancel}
          removeItemConfirmed={removeNTEThreshold}
        />
      )}
      {saveValidationModel && (
        <SaveValidationModel
          open={saveValidationModel}
          savePopupMessage={savePopupMessage}
          values1={values}
          ProjectDeatils={projectDetails}
          handleSaveConfirm={handleSaveConfirm}
          removeItemFuncConfirm={handleRemoveSavePopup}
          buttonLoading={buttonLoading}
        />
      )}
    </>
  );
}
